import AlunosTable from "../../TableAlunos/index.jsx";
import Loading from "../../../../utils/Loading/index.jsx";
import { ContainerTable, DivText, DivideTable, DivText2, NoSelected } from "../style.js";
import { IoIosArrowDropdownCircle, IoIosArrowDropupCircle } from "react-icons/io";

const AlunosSecao = ({
  loading,
  loading2,
  semAlunos,
  errorText,
  mostrarAlunosSelecionados,
  setMostrarAlunosSelecionados,
  selecionarAluno,
  handleSelecionarAluno,
  alunoLoading,
  setSearchRm,
  setSearchNome,
  mostrarAlunos,
  setMostrarAlunos,
  alunos,
  filteredAlunos,
  isEditMode,
  isRevisaoMode,
}) => {
  return (
    <>
      {loading ? (
        <ContainerTable $loading={loading}>
          <Loading />
        </ContainerTable>
      ) : isRevisaoMode ? (
        <ContainerTable $isRevisaoMode={isRevisaoMode} style={{ flex: 0, overflowY: "hidden" }}>
          {/* <DivideTable onClick={() => setMostrarAlunosSelecionados(!mostrarAlunosSelecionados)}>
            {!mostrarAlunosSelecionados ? (
              <NoSelected>
                <IoIosArrowDropupCircle />
                Clique para exibir alunos selecionados
                <IoIosArrowDropupCircle />
              </NoSelected>
            ) : (
              <NoSelected>
                <IoIosArrowDropdownCircle />
                Clique para esconder alunos selecionados
                <IoIosArrowDropdownCircle />
              </NoSelected>
            )}
          </DivideTable> */}
          {selecionarAluno?.length > 0 ? (
            <AlunosTable
              alunos={selecionarAluno}
              selecionarAluno={selecionarAluno}
              handleSelecionar={handleSelecionarAluno}
              alunoLoading={alunoLoading}
              setSearchRm={setSearchRm}
              setSearchNome={setSearchNome}
              isSelectedTable={true}
              isRevisaoMode={isRevisaoMode}
            />
          ) : null}
        </ContainerTable>
      ) : (
        <ContainerTable $loading={semAlunos}>
          {semAlunos ? (
            <DivText>{errorText || "Selecione todos os campos acima"}</DivText>
          ) : (
            <>
              <DivideTable onClick={() => setMostrarAlunosSelecionados(!mostrarAlunosSelecionados)}>
                {!mostrarAlunosSelecionados ? (
                  <NoSelected>
                    <IoIosArrowDropupCircle />
                    Clique para exibir alunos selecionados
                    <IoIosArrowDropupCircle />
                  </NoSelected>
                ) : (
                  <NoSelected>
                    <IoIosArrowDropdownCircle />
                    Clique para ocultar alunos selecionados
                    <IoIosArrowDropdownCircle />
                  </NoSelected>
                )}
              </DivideTable>
              {mostrarAlunosSelecionados && selecionarAluno.length > 0 ? (
                <AlunosTable
                  alunos={selecionarAluno}
                  selecionarAluno={selecionarAluno}
                  handleSelecionar={handleSelecionarAluno}
                  alunoLoading={alunoLoading}
                  setSearchRm={setSearchRm}
                  setSearchNome={setSearchNome}
                  isSelectedTable={true}
                />
              ) : (
                mostrarAlunosSelecionados && (
                  <>
                    <AlunosTable
                      alunos={[]}
                      selecionarAluno={selecionarAluno}
                      handleSelecionar={handleSelecionarAluno}
                      alunoLoading={alunoLoading}
                      setSearchRm={setSearchRm}
                      setSearchNome={setSearchNome}
                      isSelectedTable={true}
                      emptyMessage=" "
                    />
                    <DivText style={{ padding: "10px 0px" }}>Nenhum aluno selecionado</DivText>
                  </>
                )
              )}
              <DivideTable
                onClick={() => {
                  setMostrarAlunos(!filteredAlunos.length ? true : !mostrarAlunos);
                  setSearchRm("");
                  setSearchNome("");
                }}
              >
                {!mostrarAlunos ? (
                  <NoSelected>
                    <IoIosArrowDropupCircle />
                    Clique para exibir os alunos
                    <IoIosArrowDropupCircle />
                  </NoSelected>
                ) : (
                  <NoSelected>
                    <IoIosArrowDropdownCircle />
                    Clique para ocultar os alunos
                    <IoIosArrowDropdownCircle />
                  </NoSelected>
                )}
              </DivideTable>
              {loading2 ? (
                <DivText2>
                  <Loading />
                </DivText2>
              ) : mostrarAlunos && !alunos?.length ? (
                <DivText2 style={{ padding: "10px 0px" }}>
                  {isEditMode ? "Este curso não possui mais alunos" : errorText || "Selecione todos os campos acima"}
                </DivText2>
              ) : (
                mostrarAlunos && (
                  <AlunosTable
                    alunos={filteredAlunos}
                    selecionarAluno={selecionarAluno}
                    handleSelecionar={handleSelecionarAluno}
                    alunoLoading={alunoLoading}
                    showSearch={true}
                    setSearchRm={setSearchRm}
                    setSearchNome={setSearchNome}
                    showEmptyMessage={true}
                    emptyMessage={
                      isEditMode
                        ? !filteredAlunos?.length
                          ? "Nenhum aluno encontrado"
                          : "Nenhum aluno disponível"
                        : "Este curso não possui mais alunos"
                    }
                  />
                )
              )}
            </>
          )}
        </ContainerTable>
      )}
    </>
  );
};

export default AlunosSecao;
